import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout, { Container } from "../components/layout";
import { apiurl } from "../config/config";
import { FaFileExcel } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as XLSX from "xlsx";
import { motion } from "framer-motion";
import { IoMdClose } from "react-icons/io";
import { SuwasthiLoader } from "../components/loader";
import Pagination from "../components/pagination";
import AssignRoleModal from "../components/assignRoleModal";
import Breadcrumb from "../components/breadcrumb";

const HoldApplications = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [assignModal, setAssignModal] = useState(false);
  const [selectedApp, setSelectedApp] = useState(null);
  const [role, setRole] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedApplications, setSelectedApplications] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [paginationData, setPaginationData] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [totalItems, setTotalItems] = useState(0);
  const [page, setPage] = useState(1);
  
  const navigate = useNavigate();

  useEffect(() => {
    fetchApplications();
  }, [currentPage, itemsPerPage]);

  const fetchApplications = () => {
    setLoading(true);
    fetch(
      `${apiurl}/api/application/filter?applicationStatus=on-hold&page=${currentPage}&limit=${itemsPerPage}`
    )
      .then((res) => res.json())
      .then((data) => {
        setApplications(data.applications);
        setTotalItems(data.pagination?.totalItems || 0);
        setTotalPages(data.totalPages);
        setLoading(false);
        setPaginationData(data?.pagination);
        setSelectAll(false);
        setSelectedApplications([]);
      })
      .catch((err) => {
        console.error("Error fetching applications:", err);
        setLoading(false);
      });
  };

  const handleAssign = (app) => {
    setSelectedApp(app);
    setAssignModal(true);
  };

  const filteredApps = applications.filter((app) => {
    const nameMatch =
      app?.candidateSnapshot?.firstName
        ?.toLowerCase()
        .includes(search.toLowerCase()) ||
      app?.candidateSnapshot?.lastName
        ?.toLowerCase()
        .includes(search.toLowerCase());
    const emailMatch = app?.candidateSnapshot?.email
      ?.toLowerCase()
      .includes(search.toLowerCase());
    return nameMatch || emailMatch;
  });

  const exportToExcel = () => {
    const filteredData = applications.filter((app) => {
      const appDate = new Date(app.createdAt);
      return startDate && endDate && appDate >= startDate && appDate <= endDate;
    });
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Applications");
    XLSX.writeFile(workbook, "Applications.xlsx");
  };

  const listVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (index) => ({
      opacity: 1,
      y: 0,
      transition: { delay: index * 0.1, duration: 0.4 },
    }),
  };

  const handleLimitChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setPage(1);
  };

  useEffect(() => {
    setTotalPages(Math.ceil(totalItems / itemsPerPage) || 1);
  }, [totalItems, itemsPerPage]);

  const handleCheckboxChange = (appId) => {
    setSelectedApplications((prevSelected) =>
      prevSelected.includes(appId)
        ? prevSelected.filter((id) => id !== appId)
        : [...prevSelected, appId]
    );
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedApplications([]);
    } else {
      setSelectedApplications(applications.map((app) => app._id));
    }
    setSelectAll(!selectAll);
  };

  console.log("selectedApplications", selectedApplications);

  return (
    <Layout>
    {/* <Breadcrumb/> */}
      <Container overflow={"overflow-scroll"}>
        <div className="p-6 bg-gray-100 ">
          {/* <h2 className="text-2xl font-semibold mb-4">Application List</h2> */}
          <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4 gap-4">
            <input
              type="text"
              placeholder="Search by name or email"
              className="p-2 border rounded w-full md:w-1/3"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <DatePicker
              selected={startDate}
              onChange={setStartDate}
              placeholderText="Start Date"
              className="p-2 border rounded"
            />
            <DatePicker
              selected={endDate}
              onChange={setEndDate}
              placeholderText="End Date"
              className="p-2 border rounded"
            />
            <button
              className={`bg-green-500 text-white px-4 py-2 rounded flex items-center gap-2 ${
                !startDate || !endDate ? "opacity-50 cursor-not-allowed" : ""
              }`}
              onClick={exportToExcel}
              disabled={!startDate || !endDate}
            >
              <FaFileExcel /> Download Excel
            </button>

            {/* <button
              className="bg-green-500 text-white px-4 py-2 rounded flex items-center gap-2"
              onClick={fetchApplications}
            >
              Filter
            </button> */}
            <select
              className="p-2 border rounded"
              value={itemsPerPage}
              onChange={handleLimitChange}
            >
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="200">200</option>
              <option value="500">500</option>
            </select>
            {selectedApplications.length > 0 && (
              <button
                className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded flex items-center gap-2"
                onClick={() => setIsModalOpen(true)}
              >
                Assign
              </button>
            )}
          </div>

          {loading ? (
            <SuwasthiLoader />
          ) : (
            <div className="bg-white shadow-md rounded-lg p-4 overflow-x-auto">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="p-3">
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                    </th>
                    <th className="p-3 text-left">Application ID</th>
                    <th className="p-3 text-left">Name</th>
                    <th className="p-3 text-left">Email</th>
                    <th className="p-3 text-left">Status</th>
                    <th className="p-3 text-left">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {/* {filteredApps.map((app) => (
                    <tr key={app._id} className={`border-b ${!app.isRead ? "bg-yellow-100" : ""}`}>
                      <td className="p-3 flex items-center gap-2">
                        {app.isNewApplicant && <span className="bg-green-500 text-white px-2 py-1 text-xs rounded">New</span>}
                        {app?.id}
                      </td>
                      <td className="p-3">{app?.candidateSnapshot?.firstName} {app?.candidateSnapshot?.lastName}</td>
                      <td className="p-3">{app.candidateSnapshot?.email}</td>
                      <td className="p-3">{app.applicationStatus}</td>
                      <td className="p-3 flex gap-2">
                        <button className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600" onClick={() => handleView(app._id)}>View</button>
                        <button className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600" onClick={() => setIsModalOpen(true)}>Assign</button>
                      </td>
                    </tr>
                  ))} */}

                  {filteredApps.map((app, index) => (
                    <motion.tr
                      key={app._id}
                      className={`border-b ${
                        !app.isRead ? "bg-yellow-100" : ""
                      }`}
                      variants={listVariants}
                      initial="hidden"
                      animate="visible"
                      custom={index}
                    >
                      <td className="p-3">
                        <input
                          type="checkbox"
                          checked={selectedApplications.includes(app._id)}
                          onChange={() => handleCheckboxChange(app._id)}
                        />
                      </td>
                      {/* <td className="p-3 flex items-center gap-2">
                        {app.isNewApplicant && (
                          <motion.span
                            className="bg-green-500 text-white px-2 py-1 text-xs rounded"
                            initial={{ scale: 0 }}
                            animate={{ scale: 1 }}
                            transition={{ type: "spring", stiffness: 200 }}
                          >
                            New
                          </motion.span>
                        )}
                        {app?.id}
                      </td> */}
                      <td className="p-3 flex items-center gap-2">
                    {(() => {
                      const createdDate = new Date(app.createdAt);
                      const today = new Date();

                      const isToday =
                        createdDate.getDate() === today.getDate() &&
                        createdDate.getMonth() === today.getMonth() &&
                        createdDate.getFullYear() === today.getFullYear();

                      return isToday ? (
                        <motion.span
                          className="bg-green-500 text-white px-2 py-1 text-xs rounded"
                          initial={{ scale: 0 }}
                          animate={{ scale: 1 }}
                          transition={{ type: "spring", stiffness: 200 }}
                        >
                          New
                        </motion.span>
                      ) : null;
                    })()}
                    {app?.id}
                  </td>
                      <td className="p-3">
                        {app?.candidateSnapshot?.firstName}{" "}
                        {app?.candidateSnapshot?.lastName}
                      </td>
                      <td className="p-3">{app.candidateSnapshot?.email}</td>
                      <td className="p-3">{app.applicationStatus}</td>
                      <td className="p-3 flex gap-2">
                        <Link
                          className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                          whileHover={{ scale: 1.1 }}
                          to={`/applications/${app._id}/manage`}
                        >
                          Manage
                        </Link>
                      </td>
                    </motion.tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
        
        {isModalOpen && (
        <AssignRoleModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} selectedApplications={selectedApplications}/>
      )}
        <Pagination
          currentPage={currentPage}
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </Container>
    </Layout>
  );
};

export default HoldApplications;